export const LEADERBOARD_SCOPE_FLAG = 'AHA-48820-leaderboard-scope'

export const LEADERBOARD_SCOPES = {
  SLIDE: 'slide',
  SINCE_LAST: 'since_last',
}

export const LEADERBOARD_SCOPE_LABELS = {
  [LEADERBOARD_SCOPES.SLIDE]: 'leaderboardScopeSlide',
  [LEADERBOARD_SCOPES.SINCE_LAST]: 'leaderboardScopeSinceLast',
}

export const isLeaderboardScope = (scope) => Object.values(LEADERBOARD_SCOPES).includes(scope)

export const narrowScoredSlideIds = ({
  slides, isScoredSlide, leaderboardOrder, scope,
}) => {
  const ordered = [...slides].sort((a, b) => a.order - b.order)
  const scored = ordered.filter((slide) => isScoredSlide(slide) && slide.order <= leaderboardOrder)
  if (scope === LEADERBOARD_SCOPES.SLIDE) {
    return scored.slice(-1).map((slide) => Number(slide.id))
  }
  const previousLeaderboardOrder = ordered
    .filter((slide) => slide.type === 'leaderboard' && slide.order < leaderboardOrder)
    .reduce((latest, slide) => Math.max(latest, slide.order), -Infinity)
  return scored.filter((slide) => slide.order > previousLeaderboardOrder).map((slide) => Number(slide.id))
}
